import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding: 0 16px 16px 8px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  overflow-y: auto;
  height: 100%;
  gap: 16px;

  a {
    color: ${({ theme }) => theme.colors.black9};
    text-decoration: underline;
    font-weight: 600;
  }

  .ant-alert {
    border: 1px solid ${({ theme }) => theme.colors.purple3};
    background-color: ${({ theme }) => theme.colors.purple1};

    .ant-alert-message {
      font-size: 12px;
      font-weight: 500;
    }

    .anticon {
      color: ${({ theme }) => theme.colors.purple6};
    }
  }
`;

export const EmptyTicketsWrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
